import Vue from 'vue'
Vue.prototype.$perHelper = function (permission) {
  const permissions = JSON.parse(localStorage.getItem('userInfo')).permissions
  if (permission === true) {
    return true
  }
  return permissions.find((per) => per.slug === permission)
}
